import React, {useContext, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {resetGame, enterEditingMode, enterIdleMode, createConfirmAction} from '../actions/actions';
import {EDITING_GAME_MODE} from '../constants';
import {Button} from '@material-ui/core';
import Refresh from '@material-ui/icons/Refresh';
import Edit from '@material-ui/icons/Edit';
import {observer} from 'mobx-react';
import {StateContext} from '../App';

const propTypes = {
    score: PropTypes.number,
    resetGame: PropTypes.func,
    gameMode: PropTypes.string,
};

const Masthead = observer(() => {
    const stateContext = useContext(StateContext);

    const words = useSelector((state) => state.words);
    const {score} = stateContext;
    const gameMode = useSelector((state) => state.gameMode);
    const isInEditGameMode = gameMode === EDITING_GAME_MODE;
    const editBtnLabel = isInEditGameMode ? 'Play' : 'Edit';
    const dispatch = useDispatch();

    const [wordsNumber, setWordsNumber] = useState(words.length);

    function onRefreshGame() {
        const pendingConfirmationAction = resetGame();
        const pendingConfirmationCallback = () => {
            stateContext.reset();
            setWordsNumber(words.length);
        };
        const confirmResetGameAction = createConfirmAction({
            pendingConfirmationAction,
            msg: 'All progress will reset. Are you sure you wanna refresh the game?',
            pendingConfirmationCallback,
        });
        dispatch(confirmResetGameAction);
    }

    function onToggleGameMode() {
        const shouldGoIntoEditMode = gameMode !== EDITING_GAME_MODE;
        let exitEditMode = () => dispatch(enterIdleMode());
        // If the words number are different we need to reset the game and
        // not just resume it
        if (wordsNumber !== words.length) {
            exitEditMode = onRefreshGame;
        }
        shouldGoIntoEditMode ? dispatch(enterEditingMode()) : exitEditMode();
    }

    return (
        <div className="masthead">
            <div className="game-title">
                Words Search React Game
                <div className="credit">
                    MATTI
                    <span>BARZEEV</span>
                </div>
            </div>

            <div className="actions-container">
                <Button variant="contained" onClick={onRefreshGame} disabled={isInEditGameMode} startIcon={<Refresh />}>
                    Refresh
                </Button>
                <Button variant="contained" startIcon={<Edit />} onClick={onToggleGameMode}>
                    {editBtnLabel}
                </Button>
                <span className="score">Score: {score}</span>
            </div>
        </div>
    );
});

Masthead.propTypes = propTypes;

export default Masthead;
